<template>
  <div>
    <div class="d-flex mb-3 align-items-center">
      <div class="form-control height-auto">
        <div class="media">
          <div class="media-left align-self-center">
            <i
              v-if="!loading"
              class="fa fa-fw fa-search text-muted ml-2 mr-2 h5 mb-0"
            ></i>
            <i
              v-if="loading"
              class="fa fa-fw fa-circle-o-notch fa-spin text-muted ml-2 mr-2 h5 mb-0"
            ></i>
          </div>
          <div class="media-body align-self-center">
            <input
              type="text"
              class="form-control border-0 d-block"
              name="search"
              :placeholder="searchPlaceholder"
              v-model="filters.query"
            >
          </div>
        </div>
      </div>
      <button
        v-if="format === 'list-group-item'"
        class="btn btn-link text-decoration-none text-body ml-2"
        @click="format = 'card'"
      >
        <i class="fa fa-fw fa-th-large"></i>
      </button>
      <button
        v-if="format === 'card'"
        class="btn btn-link text-decoration-none text-body ml-2"
        @click="format = 'list-group-item'"
      >
        <i class="fa fa-fw fa-th-list"></i>
      </button>
      <button
        v-if="!showFilters"
        class="btn btn-link text-nowrap text-decoration-none text-body"
        @click.prevent="showFilters = true"
      >
        <i class="fa fa-sliders"></i>
        <span class="d-none d-md-inline-block ml-1">
          Filters
        </span>
      </button>
    </div>
    <b-card
      v-if="showFilters"
      class="mb-3"
    >

      <hr>
      <div class="text-right">
        <b-button
          variant="white"
          size="sm"
          @click.prevent="showFilters = false"
        >
          Hide Filters
        </b-button>
      </div>
    </b-card>
    <div class="row">
      <listing-item
        v-for="listing in listings"
        v-bind:key="listing.id"
        :listing="listing"
        :format="format"
      ></listing-item>
    </div>
    <div
      v-if="hasMorePages"
      class="text-center mt-2"
    >
      <button
        class="btn btn-lg btn-primary"
        :disabled="loading"
        @click.prevent="showMoreListings"
      >
        <i
          v-if="loading"
          class="fa fa-fw fa-circle-o-notch fa-spin mr-1"
        ></i>
        Show More Listings
      </button>
    </div>
  </div>
</template>

<script>
import { searchListings } from '@/api'
import ListingItem from '@/components/ListingItem'
import { merge, concat, debounce } from 'lodash'

export default {
  components: {
    ListingItem
  },
  props: {
    value: {
      type: Object,
      default () {
        return {}
      }
    },
    searchPlaceholder: {
      type: String,
      default: 'Search listings...'
    }
  },
  data () {
    return {
      format: 'list-group-item',
      loading: false,
      listings: [],
      results: {
        data: [],
        links: {},
        meta: {
          current_page: null,
          last_page: null
        }
      },
      page: 1,
      filters: {},
      showFilters: false,
      statuses: [
        { value: null, text: 'Any' },
        { value: 'ACTIVE', text: 'Active' },
        { value: 'ACTIVE UNDER CONTRACT', text: 'Active Under Contract' },
        { value: 'COMING SOON', text: 'Coming Soon' },
      ]
    }
  },
  computed: {
    searchParams () {
      return merge(this.filters, this.value, {
        page: this.page
      })
    },
    hasMorePages () {
      return this.results.meta.last_page !== null && this.results.meta.current_page < this.results.meta.last_page
    }
  },
  watch: {
    filters: {
      handler: debounce(function () {
        this.page = 1
        this.searchListings()
      }, 300),
      deep: true
    }
  },
  mounted () {
    this.searchListings()
  },
  methods: {
    async searchListings () {
      try {
        this.loading = true
        const params = this.searchParams
        const response  = await searchListings(params)
        if (params.page === 1) {
          this.listings = []
        }
        this.results = response.data
        this.listings = concat(this.listings, this.results.data)
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    showMoreListings () {
      this.page++
      this.searchListings()
    }
  }
}
</script>